import type { ReactElement } from 'react'
import type { HTMLImgProps } from '../../types'
import type { ShapeComponentType } from '../shape'

export enum IllustrationBlobType {
  neutral = 'neutral',
  warning = 'warning',
  positive = 'positive',
  critical = 'critical',
  marketing = 'marketing',
  floating = 'floating',
}

export enum IllustrationBlobSize {
  small = 's',
  medium = 'm',
  large = 'l',
  xlarge = 'xl',
  xxlarge = 'xxl',
}


interface IllustrationBlobPropsBase {
  className?: string
  type?: IllustrationBlobTypeType
  size?: IllustrationBlobSizeType
  shape: ShapeComponentType
}

type IllustrationBlobTypeType = `${IllustrationBlobType}`
export type IllustrationBlobSizeType = `${IllustrationBlobSize}`
export type IllustrationBlobProps = IllustrationBlobPropsBase & HTMLImgProps
export type IllustrationBlobComponentType = ReactElement<IllustrationBlobProps>
